import { useEffect, useState } from "react";

function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange(); // the query may have changed between render and effect
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

/* Phone-sized viewport (also true inside the native shells on phones). */
export function useIsMobile() {
  return useMediaQuery("(max-width: 640px)");
}

/* Room for a board at full size PLUS a readable second column beside it —
 * 480px board + ~300px column + gutters. Below this everything stacks. */
export function useIsWide() {
  return useMediaQuery("(min-width: 900px)");
}

/* A JS-level check, not just a CSS one (index.css's own `celebrate-pop` rule
 * covers the animation case): the drill's phase interstitial (N1) skips
 * itself immediately rather than animating for a shorter time, which a
 * stylesheet media query alone can't express. */
export function usePrefersReducedMotion() {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
